import React, { Fragment } from 'react'
import { Button, } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link,} from 'react-router-dom'
import './style.css'
export default function FirstPage(props) {
    const { data,onlineUsers,visit } = props;
    return (
        <div className='FirstPage'>
            <img className='FirstPage_Background' src='images/HomePage/FirstPage/1.png' />
            <div className='FirstPageMain'>
                <div className='FirstPageMain_Top'>
                    <div className='FirstPageMain_TopLeft'>
                        <div className='FirstPageMain_TopLeftTitle'>共性应用支撑平台</div>
                        <div className='FirstPageMain_TopLeftTitleBottom' />
                        <div style={{display:'flex',alignItems:'center',width:'100%',justifyContent:'space-between'}}>
                            <div className='FirstPageMain_TopLeftTextNum'>在线用户数  -<div className='FirstPageMain_TopLeftNum'>{onlineUsers}<div className='FirstPageMain_TopLeftNumUnit'>人次</div></div></div>
                            <div className='FirstPageMain_TopLeftTextNum'>访问量  -<div className='FirstPageMain_TopLeftNum'>{visit}<div className='FirstPageMain_TopLeftNumUnit'>次</div></div></div>
                        </div>
                        <div className='FirstPageMain_TopLeftContent'>
                            <div className='FirstPageMain_TopLeftContentText'>“创新、协调、绿色、开放、共享” 针对国家民用空间基础设施立项的陆地观测业务星和科研星共性应用支撑保障需求，按照统筹规划、分步建设、协同运行、资源共享原则，建立陆地观测卫星共性应用支撑平台。</div>
                            <div className='FirstPageMain_TopLeftContentText'>实现业务卫星和科研卫星各载荷信息产品算法检验及质量评价、资源共享，为卫星遥感应用业务部门与区域应用提供服务。</div>
                            <div className='FirstPageMain_TopLeftContentText'>发挥国家投资最大经济效益，支撑、支持、推进、推广与服务我国民用航天技术发展，并为后续进一步统筹建设和具体实施提供技术支撑。</div>
                        </div>
                        {/* <Link to={{ pathname: "/UserLogin", state: { to: "/sensing" } }}> */}
                        <Link to='/Introduce'>
                            <div className='FirstPageMain_TopLeftMore'>
                                <div className='FirstPageMain_TopLeftMoreText'>更多</div>
                                <img className='FirstPageMain_TopLeftMoreIcon' src='images/HomePage/FirstPage/more.png' />
                            </div>
                        </Link>
                    </div>
                    <div className='FirstPageMain_TopRight'>
                        <div className='FirstPageMain_TopRightTitle'>卫星系列</div>
                        <div className='FirstPageMain_TopRightTitleBottom' />
                        <div className='FirstPageMain_TopRightContent'>卫星包括空基十二五陆地观测卫星、空基十三五陆地观测卫星、高分系列卫星、资源系列卫星、环境系列卫星等在轨卫星。</div>
                        {/*<img className='FirstPageMain_TopRightImg' src='images/HomePage/FirstPage/satAll.png' />*/}
                        <img className='FirstPageMain_TopRightImg' src='images/HomePage/FirstPage/newSatAll.png' />
                        <img className='FirstPageMain_TopRightImg2' src='images/HomePage/FirstPage/hole.png' />
                    </div>
                </div>
                <div className='FirstPageMain_Bottom'>
                    <div className='FirstPageMain_BottomItemList'>
                        {data.map((item) => {
                            return (
                                <div className='FirstPageMain_BottomItem'>
                                    <div className='FirstPageMain_BottomItemTitle'>
                                        <div className='FirstPageMain_BottomItemTitleText'>{item.name === "数据存量" || item.name === "卫星数据" ? Number(item.num).toFixed(1)  : item.num}</div>
                                        <div className='FirstPageMain_BottomItemTitleType'>{item.type}</div>
                                    </div>
                                    <div className='FirstPageMain_BottomItemName'>{item.name}</div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}